import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroBanner from './components/HeroBanner';
import CategoryNav from './components/CategoryNav';
import HotRecommend from './components/HotRecommend';
import LatestUpdate from './components/LatestUpdate';
import FeatureSection from './components/FeatureSection';

export default function Home() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '小草影院',
    url: 'https://xiaocaoyingyuan.com/',
    description: '小草影院免费在线看电影电视剧，全站资源不收费、不缓冲秒开播。无需注册即点即看，流畅观影体验尽在小草影视。',
    inLanguage: 'zh-CN',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://xiaocaoyingyuan.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '小草影院',
    url: 'https://xiaocaoyingyuan.com/',
    description: '小草影院致力于提供免费高清在线观影服务',
    foundingDate: '2020',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'service@xiaocaoyingyuan.com',
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroBanner />
          <CategoryNav />
          <HotRecommend />
          <LatestUpdate />
          <FeatureSection />

          <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50" aria-label="观影指南">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-8 md:mb-10">
                <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950">
                  为什么选择小草影院
                </h2>
                <p className="mt-2 text-sm text-foreground-500">数百万用户信赖的免费观影平台</p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
                {[
                  {
                    icon: 'ri-shield-check-line',
                    title: '安全可靠',
                    desc: '全站无病毒无广告弹窗，纯净观影环境，保护您的设备安全与隐私。',
                  },
                  {
                    icon: 'ri-flashlight-line',
                    title: '极速播放',
                    desc: '采用先进的CDN加速技术，高清视频秒加载，告别卡顿与缓冲等待。',
                  },
                  {
                    icon: 'ri-smartphone-line',
                    title: '多端适配',
                    desc: '完美适配电脑、平板、手机等所有设备，随时随地畅享观影乐趣。',
                  },
                  {
                    icon: 'ri-24-hours-line',
                    title: '实时更新',
                    desc: '7×24小时不间断更新，最新电影电视剧第一时间上架，永不错过精彩。',
                  },
                ].map((item) => (
                  <div
                    key={item.title}
                    className="p-5 md:p-6 bg-background-50 border border-background-200/70 rounded-xl hover:border-primary-200 transition-all duration-300"
                  >
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-50 text-primary-500 mb-4">
                      <i className={`${item.icon} text-lg`}></i>
                    </div>
                    <h3 className="text-base font-semibold text-foreground-800 mb-2">{item.title}</h3>
                    <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}